var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTracker40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.587 22.0386C33.0515 21.8684 35 19.8475 35 17.3779C35 15.1218 33.3737 13.2401 31.2136 12.8097C31.0976 9.30763 28.18 6.50293 24.5978 6.50293C22.2965 6.50293 20.2694 7.66054 19.0833 9.41726C18.2909 9.01598 17.3922 8.78979 16.44 8.78979C13.2367 8.78979 10.64 11.3494 10.64 14.5069C10.64 14.565 10.6409 14.6228 10.6426 14.6804C10.3673 14.6151 10.079 14.5815 9.78261 14.5815C7.69353 14.5815 6 16.2508 6 18.3101C6 20.3693 7.69353 22.0386 9.78261 22.0386H30.587Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1404 30.4098C24.8544 30.4102 23.5586 30.4142 23.4058 30.4097C21.1137 30.3427 19.4644 27.7165 19.4644 24.5999C19.4644 19.8692 21.8977 15.9202 24.1951 14.994C24.5027 14.8594 24.8206 14.7886 25.1411 14.7886L25.1608 14.7889L25.1805 14.7886C25.501 14.7886 25.8188 14.8594 26.1265 14.9942C28.4239 15.9202 30.8572 19.8692 30.8572 24.5999C30.8572 27.7165 29.2078 30.3427 26.9157 30.4097C26.763 30.4142 25.4672 30.4102 25.1812 30.4098H25.1404Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2666 23.355V34.812",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2661 28.5368L22.9453 26.0371",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTracker40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTracker40.d02639da911f62b6b5d78bb446d2c644.svg";
export { ForwardRef as ReactComponent };